module.exports = __webpack_public_path__ + "static/3-a7c06dc021e133ec721edfe7a2a56c98.jpg";